module.exports = __webpack_public_path__ + "img/qhdx.24dcd430.svg";